import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLaos = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_557)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M22.8092 6.78263C20.8682 2.76867 16.7575 0 12 0C7.24242 0 3.13167 2.76867 1.19067 6.78263L12 7.82611L22.8092 6.78263Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.19067 17.2174C3.13167 21.2313 7.24242 24 12 24C16.7575 24 20.8682 21.2313 22.8092 17.2174L12 16.1739L1.19067 17.2174Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.8093 6.78263H1.19072C0.427875 8.3602 0 10.1301 0 12C0 13.8699 0.427875 15.6398 1.19072 17.2174H22.8092C23.5722 15.6398 24 13.8699 24 12C24 10.1301 23.5722 8.3602 22.8093 6.78263Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 16.1739C14.3051 16.1739 16.1738 14.3052 16.1738 12C16.1738 9.69482 14.3051 7.82611 11.9999 7.82611C9.69476 7.82611 7.82605 9.69482 7.82605 12C7.82605 14.3052 9.69476 16.1739 11.9999 16.1739Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_557",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgLaos;
